export enum MmFaultRightPanePageEnum {
  fault = 'mm-fault-right-pane',
  editFault = 'mm-fault-edit-right-pane',
  addActivity = 'mm-add-activity-right-pane',
  editActivity = 'mm-edit-activity-right-pane',
  addAttachments = 'mm-add-attachments-right-pane',
  fieldConfiguration = 'mm-field-configuration-right-pane',
  selectStructure = 'mm-select-structure',
  plan = 'mm-plan-right-pane'
}
